import { languageList, useTranslation } from '@pancakeswap/localization'
import { footerLinks, Menu as UikitMenu, NextLinkFromReactRouter, useModal } from '@pancakeswap/uikit'
import USCitizenConfirmModal from 'components/Modal/USCitizenConfirmModal'
import { NetworkSwitcher } from 'components/NetworkSwitcher'
import PhishingWarningBanner from 'components/PhishingWarningBanner'
import { useCakeBusdPrice } from 'hooks/useBUSDPrice'
import useTheme from 'hooks/useTheme'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { usePhishingBanner } from '@pancakeswap/utils/user'
import { IdType } from 'hooks/useUserIsUsCitizenAcknowledgement'
import { useCakePrice } from '@pancakeswap/utils/useCakePrice'
import { ChainId } from '@pancakeswap/sdk'
import BigNumber from 'bignumber.js'
import GlobalSettings from './GlobalSettings'
import { SettingsMode } from './GlobalSettings/types'
import { useMenuItems } from './hooks/useMenuItems'
import UserMenu from './UserMenu'
import { getActiveMenuItem, getActiveSubMenuItem } from './utils'

const LinkComponent = (linkProps) => {
  return <NextLinkFromReactRouter to={linkProps.href} {...linkProps} prefetch={false} />
}

const Menu = (props) => {
  const { chainId } = useActiveChainId()
  const { isDark, setTheme } = useTheme()
  
  // price/cake
  const cakePriceUsd = useCakeBusdPrice()
  // const { data: dataPrice } = useCakePrice()
  // let cakePrice = new BigNumber(0)
  // if (dataPrice) {
  //   cakePrice = new BigNumber(dataPrice)
  // }
  // const cakePriceUsd = cakePrice

  const { currentLanguage, setLanguage, t } = useTranslation()
  const { pathname } = useRouter()
  const [onUSCitizenModalPresent] = useModal(
    <USCitizenConfirmModal title={t('Hyper-Dex Exchange Swap Perpetuals')} id={IdType.PERPETUALS} />,
    false,
    false,
    'usCitizenConfirmModal',
  )
  const [showPhishingWarningBanner] = usePhishingBanner()

  const menuItems = useMenuItems(onUSCitizenModalPresent)

  const activeMenuItem = getActiveMenuItem({ menuConfig: menuItems, pathname })
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })

  const toggleTheme = useMemo(() => {
    return () => setTheme(isDark ? 'light' : 'dark')
  }, [setTheme, isDark])

  const getFooterLinks = useMemo(() => {
    return footerLinks(t)
  }, [t])

  const [linkBuy, setLinkBy] = useState('')
  useEffect(() => {
    if(chainId === ChainId.BSC) {
      setLinkBy(
        `${process.env.NEXT_PUBLIC_URL}/swap?outputCurrency=0x8844bC1b43B89E8096f8E2e6DF9781A253E3fC3e&chainId=${chainId}`,
      )
    }
    else if (chainId === ChainId.ALL) {
      setLinkBy(
        `${process.env.NEXT_PUBLIC_URL}/swap?outputCurrency=0x0d9793861AEB9244AD1B34375a83A6730F6AdD38&chainId=${chainId}`,
      )
    }
    else if (chainId === ChainId.ETHEREUM) {
      setLinkBy(
        `${process.env.NEXT_PUBLIC_URL}/swap?outputCurrency=0xA0bE76135289aEB5781923eE0d47Ca5527821F59&chainId=${chainId}`,
      )
    }
  }, [chainId])

    return (
      <>
        <UikitMenu
          linkComponent={LinkComponent}
          rightSide={
            <>
              <GlobalSettings mode={SettingsMode.GLOBAL} />
              <NetworkSwitcher />
              <UserMenu />
            </>
          }
          chainId={chainId}
          banner={showPhishingWarningBanner && typeof window !== 'undefined' && <PhishingWarningBanner />}
          isDark={isDark}
          toggleTheme={toggleTheme}
          currentLang={currentLanguage.code}
          langs={languageList}
          setLang={setLanguage}
          cakePriceUsd={cakePriceUsd}
          links={menuItems}
          subLinks={activeMenuItem?.hideSubNav || activeSubMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
          footerLinks={getFooterLinks}
          activeItem={activeMenuItem?.href}
          activeSubItem={activeSubMenuItem?.href}
          buyCakeLabel={t('Buy HYDX')}
          buyCakeLink={linkBuy}
          {...props}
        />
      </>
    )
}

export default Menu
